import React, { Component } from 'react'
import LoaderDots from '../loaderDots'
import { isMobile } from 'react-device-detect';

class CertifiedBlackBeltsList extends Component {
  mobileRowsList(athletes) {
    return athletes.map((athlete, index) => {
      return (
        <React.Fragment>
          <tr
            key={index}
            data-toggle='collapse'
            data-target={`#line-${index}`}
            data-parent='#black-belts-list'
          >
            <td className='name bg-lighter'>{athlete.attributes.name}</td>
            <td className='graduation bg-darker'>{ this.props.i18n.t(`certifiedBlackBelts.belts.${athlete.attributes.belt}`) }</td>
            <td className='academy bg-lighter d-none d-sm-table-cell'>{athlete.attributes.academy}</td>
          </tr>

          <tr id={`line-${index}`} className='collapse' key={`line-${index}`}>
            <td className='bg-lighter'>
              <ul className='fa-ul'>
                <li>
                  <span className="fa-li"><i className="fa fa-chevron-right"></i></span>
                  {athlete.attributes.academy}
                </li>
              </ul>
            </td>
            <td className='bg-darker'></td>
          </tr>
        </React.Fragment>
      )
    })
  }

  rowsList(athletes) {
    return athletes.map((athlete, index) => {
      return(
        <tr key={index}>
          <td className='name bg-lighter'>{athlete.attributes.name}</td>
          <td className='graduation bg-darker'>{ this.props.i18n.t(`certifiedBlackBelts.belts.${athlete.attributes.belt}`) }</td>
          <td className='academy bg-lighter d-none d-sm-table-cell'>{athlete.attributes.academy}</td>
        </tr>
      )
    })
  }

  render() {
    const { athletes, loading, error, errorStatus, errorBody, i18n } = this.props;

    // Returning console.log() here rendered nothing at all, so a failed search
    // left the page silently empty. A throttled search gets its own message: it
    // is the one error the visitor can act on by waiting, and an office or gym
    // behind a single address can reach the per-IP limit legitimately. An upstream
    // 429 is core's shared floor, which other visitors' traffic can trip, so it
    // falls back to the generic copy rather than blaming this connection.
    if (error) {
      const throttled =
        errorStatus === 429 && !(errorBody && errorBody.source === 'upstream')

      return (
        <div className='search-failed'>
          <h5>
            {i18n.t(
              throttled
                ? 'certifiedBlackBelts.list.tooManyRequestsMessage'
                : 'certifiedBlackBelts.list.generalErrorMessage'
            )}
          </h5>
          <h6>
            {i18n.t(
              throttled
                ? 'certifiedBlackBelts.list.tryAgainShortly'
                : 'certifiedBlackBelts.list.workingOn'
            )}
          </h6>
        </div>
      )
    }

    if (!athletes.length && !loading) {
      return(
        <div className='athletes-not-found'>
          <h5>{i18n.t("certifiedBlackBelts.list.notFoundMessage")}</h5>
          <h6>{i18n.t("certifiedBlackBelts.list.changeFilters")}</h6>
        </div>
      )
    };

    if (loading) return(
      <div className='h-100 d-flex justify-content-center align-items-center'>
        <LoaderDots />
      </div>
    )

    return(
      <div className='table-container'>
        <table width='100%' id='black-belts-list'>
          <thead>
            <tr>
              <th className='bg-primary'>{i18n.t("certifiedBlackBelts.list.name")}</th>
              <th className='bg-darker'>{i18n.t("certifiedBlackBelts.list.graduation")}</th>
              <th className='bg-primary d-none d-sm-table-cell'>{i18n.t("certifiedBlackBelts.list.academy")}</th>
            </tr>
          </thead>
          <tbody>{isMobile ? this.mobileRowsList(athletes) : this.rowsList(athletes) }</tbody>
        </table>
      </div>
    )
  }
}

export default CertifiedBlackBeltsList;
